import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgConnectionRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22 7.8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M20.6 10q.4.6 1.2 1L20 20.5q-.7.1-1.5.5L12 15.3a4 4 0 0 0 .3-1.8zm3.4 1.4A3.7 3.7 0 1 0 19.8 8l-8.4 3.4a3.7 3.7 0 1 0-1 5.6l6.7 5.7a3.8 3.8 0 0 0 3.4 5.3 3.7 3.7 0 0 0 1.7-7zm-5 12.8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-10.5-12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
	})
});
export default SvgConnectionRegularIcon;
